import {SynopticElementEventPreview, SynopticElementStatePreview} from '../synoptics/synoptic-configuration-csv-types';

export class SynopticStatesRequest {
  states: SynopticElementStatePreview[];
  events: SynopticElementEventPreview[];

  constructor(states: SynopticElementStatePreview[], events: SynopticElementEventPreview[]) {
    this.states = states;
    this.events = events;
  }
}
